import JobZImage from "../../../common/jobz-img";
import { NavLink, useNavigate } from "react-router-dom";
import { empRoute, employer, publicUser } from "../../../../globals/route-names";
import { useAuth } from "../../../../context/AuthContext";

function EmpHeaderSection(props) {
    const navigate = useNavigate();
    const { user, logout, deleteProfile } = useAuth();

    const handleLogout = async () => {
        if (!window.confirm("Logout from your employer account?")) return;
        await logout();
        navigate(publicUser.pages.LOGIN);
    };

    const handleDeleteProfile = async () => {
        if (!window.confirm("Delete this employer profile? Your account will be deactivated and you will be logged out.")) return;
        await deleteProfile();
        navigate(publicUser.pages.LOGIN);
    };

    return (
        <>
            <header id="header-admin-wrap" className="header-admin-fixed">
                {/* Header Start */}
                <div id="header-admin" className={props.sidebarActive ? "" : "active"}>
                    <div className="container">
                        {/* Left Side Content */}
                        <div className="header-left">
                            <div className="nav-btn-wrap">
                                <button className="nav-btn-admin" id="sidebarCollapse" type="button" onClick={props.onClick}>
                                    <span className="fa fa-angle-left" />
                                </button>
                            </div>
                        </div>
                        {/* Left Side Content End */}
                        {/* Right Side Content */}
                        <div className="header-right">
                            <ul className="header-widget-wrap">
                                {/*Message*/}
                                <li className="header-widget dashboard-message-dropdown">
                                    <div className="dropdown">
                                        <button type="button" className="dropdown-toggle jobzilla-admin-messange" id="ID-MSG_dropdown" data-bs-toggle="dropdown">
                                            <i className="far fa-envelope" />
                                            <span className="notification-animate">4</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="ID-MSG_dropdown">
                                            <div className="message-list dashboard-widget-scroll">
                                                <ul>
                                                    <li className="clearfix">
                                                        <span className="msg-avtar">
                                                            <JobZImage src="images/user-avtar/pic1.jpg" alt="" />
                                                        </span>
                                                        <div className="msg-texting">
                                                            <strong>Alexa Johnson</strong>
                                                            <small className="msg-time">
                                                                <span className="far fa-clock p-r-5" />12 mins ago
                                                            </small>
                                                            <p>Hello! I'm interested in applying for the IT Contractor vacancy...</p>
                                                        </div>
                                                    </li>
                                                    <li className="clearfix">
                                                        <span className="msg-avtar">
                                                            <JobZImage src="images/user-avtar/pic2.jpg" alt="" />
                                                        </span>
                                                        <div className="msg-texting">
                                                            <strong>Johan Smith</strong>
                                                            <small className="msg-time">
                                                                <span className="far fa-clock p-r-5" />2 hours ago
                                                            </small>
                                                            <p>Hi, I have updated my portfolio files on my profile...</p>
                                                        </div>
                                                    </li>
                                                    <li className="clearfix">
                                                        <span className="msg-avtar">
                                                            <JobZImage src="images/user-avtar/pic3.jpg" alt="" />
                                                        </span>
                                                        <div className="msg-texting">
                                                            <strong>Bobby Brown</strong>
                                                            <small className="msg-time">
                                                                <span className="far fa-clock p-r-5" />3 hours ago
                                                            </small>
                                                            <p>Please let me know if Wednesday works for the call...</p>
                                                        </div>
                                                    </li>
                                                    <li className="clearfix">
                                                        <span className="msg-avtar">
                                                            <JobZImage src="images/user-avtar/pic4.jpg" alt="" />
                                                        </span>
                                                        <div className="msg-texting">
                                                            <strong>David Deo</strong>
                                                            <small className="msg-time">
                                                                <span className="far fa-clock p-r-5" />4 hours ago
                                                            </small>
                                                            <p>Can you confirm the expected budget for the contract...</p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div className="message-view-all">
                                                    <NavLink to={empRoute(employer.MESSAGES1)}>View All</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {/*Notification*/}
                                <li className="header-widget dashboard-noti-dropdown">
                                    <div className="dropdown">
                                        <button type="button" className="dropdown-toggle jobzilla-admin-notification" id="ID-NOTI_dropdown" data-bs-toggle="dropdown">
                                            <i className="far fa-bell" />
                                            <span className="notification-animate">8</span>
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="ID-NOTI_dropdown">
                                            <div className="dashboard-widgets-header">You have 7 notifications</div>
                                            <div className="noti-list dashboard-widget-scroll">
                                                <ul>
                                                    <li>
                                                        <NavLink to={empRoute(employer.CANDIDATES)}>
                                                            <span className="noti-icon"><i className="far fa-bell" /></span>
                                                            <span className="noti-texting">Devid applied for <b>Webdesigner.</b> </span>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={empRoute(employer.MESSAGES1)}>
                                                            <span className="noti-icon"><i className="far fa-bell" /></span>
                                                            <span className="noti-texting">Nikol sent you a message. </span>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={empRoute(employer.MANAGE_JOBS)}>
                                                            <span className="noti-icon"><i className="far fa-bell" /></span>
                                                            <span className="noti-texting">lucy bookmarked your <b>SEO Expert</b> Job! </span>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={empRoute(employer.MANAGE_JOBS)}>
                                                            <span className="noti-icon"><i className="far fa-bell" /></span>
                                                            <span className="noti-texting">Your job for <b>teacher</b> has been approved! </span>
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={empRoute(employer.CANDIDATES)}>
                                                            <span className="noti-icon"><i className="far fa-bell" /></span>
                                                            <span className="noti-texting">Thor applied for <b>Team Leader</b>. </span>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                                <div className="noti-view-all">
                                                    <NavLink to={empRoute(employer.RESUME_ALERTS)}>View All</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {/*Account*/}
                                <li className="header-widget">
                                    <div className="dashboard-user-section">
                                        <div className="listing-user">
                                            <div className="dropdown">
                                                <button type="button" className="dropdown-toggle" id="ID-ACCOUNT_dropdown" data-bs-toggle="dropdown">
                                                    <div className="user-name text-black">
                                                        <span>
                                                            <JobZImage src={user?.avatar_url || "images/user-avtar/pic4.jpg"} alt="" />
                                                        </span>{user?.name || "Employer"}
                                                    </div>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="ID-ACCOUNT_dropdown">
                                                    <ul>
                                                        <li><NavLink to={empRoute(employer.DASHBOARD)}><i className="fa fa-home" />Dashboard</NavLink></li>
                                                        <li><NavLink to={empRoute(employer.MESSAGES1)}><i className="fa fa-envelope" /> Messages</NavLink></li>
                                                        <li><NavLink to={empRoute(employer.PROFILE)}><i className="fa fa-user" /> Profile</NavLink></li>
                                                        <li><button type="button" className="employer-account-action" onClick={handleDeleteProfile}><i className="fa fa-trash-alt" /> Delete Profile</button></li>
                                                        <li><button type="button" className="employer-account-action" onClick={handleLogout}><i className="fa fa-share-square" /> Logout</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {/* Right Side Content End */}
                    </div>
                </div>
                {/* Header End */}
            </header>

        </>
    )
}

export default EmpHeaderSection;
